export class CardData {
  // cardFunc: (int, List<CardData> => List<CardData> )
  constructor(intVal, cardFuncContainer) {
    this.intVal = intVal;

    this.cardFuncContainer = cardFuncContainer;
  }
}

export const CardDiffStatus = Object.freeze({
  unchanged: 0,
  modified: 1,
  added: 2,
  deleted: 3,
});

export class CardDiffData {
  constructor(intVal, cardFuncContainer, diffStatus, prevIdxOpt) {
    //this.intVal = intVal;
    //this.cardFuncContainer = cardFuncContainer;
    this.cardData = new CardData(intVal, cardFuncContainer);
    this.diffStatus = diffStatus;
    this.prevIdxOpt = prevIdxOpt;
  }
}